import React, {useCallback, useEffect, useState} from 'react';
import { getSeeAllGamesLink, redirectUser } from '../../utils/navigation';
import CONFIG from '../../config';
import { getSvgComponent } from '../utils/svg';
import { CloudSeparator, ViewCloudGamesItem, ViewCloudGamesItemLink } from './PartnerGamesStyle';
import { ICloud } from '../../types/content';

interface ICloudItemProps {
  cloudItem: ICloud;
  singleItem: boolean;
  firstItem: boolean;
}

const CloudItem = ({ cloudItem, singleItem, firstItem }: ICloudItemProps) => {
  const [clickedButton, setButtonClicked] = useState(false);

  useEffect(() =>  {
     setTimeout(() =>  {
        setButtonClicked( false )
     },1500)
  },[clickedButton])

  const cloudItemClicked = useCallback(() => {
    setButtonClicked(true);
    redirectUser(getSeeAllGamesLink(CONFIG.countryCode, cloudItem.filter));
  }, [redirectUser, setButtonClicked]);

  return (
    <ViewCloudGamesItem clicked={clickedButton} singleItem={singleItem} firstItem={firstItem} onClick={() => cloudItemClicked()}>
      {getSvgComponent(cloudItem.svg)}
      {singleItem && <CloudSeparator/>}
      <ViewCloudGamesItemLink singleItem={singleItem}>{cloudItem.text}</ViewCloudGamesItemLink>
    </ViewCloudGamesItem>
  );
};

export default CloudItem;